<script setup>
import { reactive, computed, watch, getCurrentInstance } from 'vue';
import { Countries } from '/src/app/features/shared/libraries/countries.js';

const props = defineProps({
  selectedCountry: {
    type: String,
    required: true
  }
});

const { proxy } = getCurrentInstance();
const { $bus, $constants, $stores } = proxy;

const sourceData = computed(() => $stores.appData?.state?.data?.fees || {});

const form = reactive({
  phoneVerification: 100
});

watch(
  [sourceData, () => props.selectedCountry],
  ([data, country]) => {
    if (data && data[country]) {
      form.phoneVerification = data[country].phoneVerification || 100;
    } else {
      form.phoneVerification = 100;
    }
  },
  { immediate: true, deep: true }
);

const hasChanges = computed(() => {
  return form.phoneVerification !== (sourceData.value?.[props.selectedCountry]?.phoneVerification || 100);
});

function save() {
  if (!hasChanges.value) return;

  const payload = { fees: {} };
  payload.fees[props.selectedCountry] = {
    phoneVerification: form.phoneVerification
  };

  $bus.emit($constants.EVENTS.APP_DATA.UPDATE_FEES, payload);
}

function reset() {
  if (sourceData.value?.[props.selectedCountry]) {
    form.phoneVerification = sourceData.value[props.selectedCountry].phoneVerification || 100;
  } else {
    form.phoneVerification = 100;
  }
}
</script>

<template>
  <div class="bg-white rounded-2xl shadow-sm p-6 border border-gray-100 space-y-6">
    <!-- HEADER -->
    <div class="flex justify-between items-center pb-4 border-b border-gray-100">
      <div class="flex items-center gap-3">
        <span class="text-2xl">📱</span>
        <div>
          <h3 class="text-lg font-bold text-gray-800">Frais de vérification téléphone</h3>
          <p class="text-sm text-gray-500">Configuré pour {{ Countries.find(props.selectedCountry)?.countryName || props.selectedCountry }}</p>
        </div>
      </div>
      <div class="flex gap-3" v-show="hasChanges">
        <button
          class="px-4 py-2 rounded-xl bg-gray-100 text-gray-600 font-medium hover:bg-gray-200 transition-all"
          @click="reset"
        >
          Annuler
        </button>
        <button
          class="px-4 py-2 rounded-xl bg-primary-600 text-white font-medium hover:bg-primary-700 shadow-lg shadow-primary-100 transition-all"
          @click="save"
        >
          Sauvegarder
        </button>
      </div>
    </div>

    <!-- FIELD -->
    <div class="max-w-md">
      <label class="block mb-2 text-sm font-semibold text-gray-600 uppercase tracking-wider ml-1">
        Montant des frais (en monnaie locale)
      </label>
      <div class="relative group">
        <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400 group-focus-within:text-primary-500 transition-colors">
          <span class="font-bold text-lg">💰</span>
        </div>
        <input
          type="number"
          class="inputComponent !pl-12 !py-4 !text-xl !font-bold"
          v-model.number="form.phoneVerification"
        />
      </div>
      <p class="mt-2 text-xs text-gray-400 italic">
        * Ce montant sera facturé aux clients lors de l'envoi du code de vérification SMS.
      </p>
    </div>
  </div>
</template>
